import React from "react";
import PageContent from "../components/PageContent";
import { Link, redirect, useRouteError } from "react-router-dom";

const SuccessAuthPages = () => {
  return (
    <PageContent>
      <div className="error-page" style={{ backgroundColor: "white" }}>
        <img
          src="/img-1.png"
          className="top-left-image"
          alt="Top Left"
          style={{ backgroundColor: "transparent" }}
        />
        <div className="error-content p-3" style={{ backgroundColor: "white" }}>
          <h1 className="error-title" style={{ backgroundColor: "white" }}>
            Thank you to register as new user. Your account is under approval
            process.
          </h1>
          <Link
            style={{ backgroundColor: "white" }}
            to="/auth"
            className="login-Link btn btn-lg btn-primary mt-3"
          >
            Back
          </Link>
        </div>
        <img
          src="/img-2.png"
          className="bottom-right-image"
          alt="Bottom Right"
          style={{ backgroundColor: "transparent" }}
        />
        <div className="muted-text" style={{ backgroundColor: "white" }}>
          © 2023 Colibri LMS. All rights reserved.
        </div>
      </div>
    </PageContent>
  );
};

export default SuccessAuthPages;
